t = require('app/scripts/views/internal/teacup-with-helpers')('tooltip_content')

module.exports = ->
  closeable = t.mustacheVar('closeable')
  style = t.mustacheVar('style')

  classList = if closeable then ['.tooltip-content-closeable'] else []

  t.div (classList.join('') + ".tooltip-content.js-tooltip-content"), ->
    if closeable
      t.icon 'close', { class: 'tooltip-close-button js-tooltip-close-button' }
    t.raw t.mustacheVar('tooltipHtml')
